import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { SessionStore } from '~/stores/session'
import { PlanType, WaypointResult } from '~/generated/api-clients-generated'

export class SelectedPlanTypeNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const session = SessionStore.use()

    switch (session.planType) {
      case PlanType.MAPD:
        return this._destinations.get(WaypointResult.PlanType_MA) ?? null
      case PlanType.PDP:
        return this._destinations.get(WaypointResult.PlanType_PDP) ?? null
      case PlanType.GAP:
        return this._destinations.get(WaypointResult.PlanType_MS) ?? null
      case null:
        return this._destinations.get(WaypointResult.PlanType_Unsure) ?? null
      default:
        return null
    }
  }
}
